import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DrawerState {
    drawerOpen: boolean;
}

const initialState: DrawerState = {
    drawerOpen: true,
};

const drawerSlice = createSlice({
    name: 'drawer',
    initialState,
    reducers: {
        isDrawerState: (state, action: PayloadAction<boolean>) => {
            state.drawerOpen = action.payload;
        },
    },
});

export const { isDrawerState } = drawerSlice.actions;

export default drawerSlice.reducer;
